export default __webpack_public_path__ + "static/media/portfolio.fa1291b9.svg";